import type { FC, RefObject } from 'react';
import { Picture } from '@ui';
import type { ShopFragmentMainEndpointFragment } from '@schema/main';
import { oysterBarBookTableBackground } from '@images';
import { observer } from 'mobx-react';
import icons from '@icons';
import './styles.scss';
import { useBookTable } from './useBookTable';

interface BookTableProps {
  shopInfo?: ShopFragmentMainEndpointFragment;
  ref?: RefObject<HTMLDivElement | null>;
}

const {
  pin: { white: pinWhiteFilled }
} = icons.Fill;

const BookTable: FC<BookTableProps> = observer(({ shopInfo, ref }) => {
  const {
    oysterBars,
    selectedBarId,
    setSelectedBarId,
    selectedAddress,
    reserveUrl,
    routeUrl,
    handleBookingClick
  } = useBookTable(shopInfo);

  return (
    <section ref={ref} className='book-table' id='booking'>
      <Picture
        icon={oysterBarBookTableBackground}
        pictureClassName='book-table__background'
      />

      <div className='book-table__container'>
        <div className='book-table__form'>
          <h2 className='book-table__title'>Забронировать стол</h2>

          <div className='book-table__form-inputs'>
            <div className='book-table__select-wrapper'>
              <select
                className='book-table__select'
                value={selectedBarId}
                onChange={event => setSelectedBarId(event.target.value)}
              >
                <option value=''>Выбрать бар</option>
                {oysterBars.map(restaurant => (
                  <option key={restaurant.value} value={restaurant.value}>
                    {restaurant.label}
                  </option>
                ))}
              </select>
            </div>

            <div className='book-table__form-row book-table__form-row--booking-details'>
              <div className='book-table__form-submit'>
                <a
                  className='buttonUI large red primary btn default'
                  href={reserveUrl ?? undefined}
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={handleBookingClick}
                  aria-disabled={!reserveUrl}
                >
                  <span>Забронировать</span>
                </a>
              </div>
            </div>

            {selectedAddress && (
              <a
                className='book-table__address-block'
                href={routeUrl ?? undefined}
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className='book-table__address-heading'>
                  <Picture
                    icon={pinWhiteFilled}
                    width='24'
                    height='24'
                    pictureClassName='book-table__address-icon'
                  />
                  <span>Адрес бара</span>
                </span>
                <span className='book-table__address-text'>
                  {selectedAddress}
                </span>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
});

export default BookTable;
